import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 130px;
    background-color: #F6F5FA;
    border-radius: 12px;
    margin-top: 25px;

    @media(max-width: 768px){
        height: 108px;
    }
`;

export const ContainerWithTitle = styled.div`
    padding: 19px 19px 12px 15px;

    @media (max-width: 1200px) {
        #descriptiveIcon {
            height: 38px;
        }
    }
`;

export const Title = styled.h1`
    font: normal normal normal 11px Circular Std Book;
    color: #454546;
    margin-bottom: 0px;
`;

export const Date = styled.span`
    font: normal normal normal 10px Circular Std Book;
    color: #B8B4CC;
    /* margin-left: 7px; */
`;

export const Value = styled.h2`
    font: normal normal normal 20px Circular Std Book;
    color: #F58B1E;
    line-height: 1;
    margin: 0;
`;

export const ValueAndImageContainer = styled.div`
    display: flex;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 19px 19px 12px 15px;
`

export const PostScriptum = styled.span`
    font: normal normal normal 8px Circular Std Book;
    color: #B8B4CC;
`;